var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DeleteConfirmationModal',{attrs:{"show":_vm.show,"isLoading":_vm.isLoading,"title":_vm.titleText,"text":_vm.deleteText},on:{"cancel":function($event){return _vm.$emit('cancel')},"delete":_vm.removeFinding}})
}
var staticRenderFns = []

export { render, staticRenderFns }